export default [
  {
    path: '/personal',
    name: 'personalLayout',
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/personal/:id',
        name: 'personal',
        component: () => import('@/views/personal'),
        meta: {
          keepAlive: true,
          includeKeepAlive: ['detail']
        }
      }
    ]
  }
]